export default function Marty() {
  return (
    <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <span style={{ fontSize: '2rem', fontWeight: 'bold' }}>WELCOME MARTY</span>
    </div>
  );
}
